import { render, staticRenderFns } from "./JuicerFeed.vue?vue&type=template&id=9b049974&"
import script from "./JuicerFeed.vue?vue&type=script&lang=js&"
export * from "./JuicerFeed.vue?vue&type=script&lang=js&"
import style0 from "./JuicerFeed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports